module.exports = __webpack_public_path__ + "assets/heroku.83407ca0.svg";